package dev.lingvo.ops.pages.jobs.jobId

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.rememberPageContext
import dev.lingvo.ops.api.OpsApi
import dev.lingvo.ops.components.OpsFact
import dev.lingvo.ops.components.OpsPageHeader
import dev.lingvo.ops.components.OpsPanel
import dev.lingvo.ops.components.OpsResourceStates
import dev.lingvo.ops.components.OpsShell
import dev.lingvo.ops.state.leaseNote
import dev.lingvo.ops.state.refundedLabel
import dev.lingvo.ops.state.rememberOpsResource
import dev.lingvo.site.ds.LBadge
import dev.lingvo.site.ds.LBadgeVariant
import dev.lingvo.site.ds.Space
import dev.lingvo.site.ds.formatCount
import dev.lingvo.site.ds.formatUtc
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text

@Page("/jobs/{jobId}")
@Composable
fun JobPage() {
    val id = rememberPageContext().route.params["jobId"].orEmpty()
    OpsShell("Jobs") {
        val resource = rememberOpsResource(id, OpsApi::job)
        Column(Modifier.fillMaxWidth().gap(Space.XL)) {
            OpsPageHeader("Job", "Inspect the recorded outcome, lease and credit effects for this job.", resource.state.isRefreshing, resource::refresh)
            OpsResourceStates(resource.state, "Job not found", "This job has no accessible record.", retry = resource::refresh) { detail ->
                val job = detail.job
                OpsPanel("Recorded outcome") {
                    OpsFact("State", job.state.name)
                    OpsFact("Provider", job.provider.displayName)
                    OpsFact("Failure class", job.failureClass.name)
                    OpsFact("Refunded", refundedLabel(job.state, job.refundedCredits))
                    OpsFact("Created", formatUtc(job.createdAt))
                }
                OpsPanel("Lease") {
                    if (detail.lease == null) P { Text("No lease details were returned.") }
                    else leaseNote(detail.lease)?.let { note ->
                        LBadge("Abandoned risk", variant = LBadgeVariant.WARNING)
                        P { Text(note) }
                    } ?: P { Text("No expired-lease finding in the recorded result.") }
                }
                OpsPanel("Failure classification") {
                    P { Text("Lingvo classifies failures server-side. Raw recorded error text may contain translation content and stays in the database.") }
                    P { Text(if (job.hadEarlierFailure) "An earlier failure was recorded." else "No earlier failure was recorded.") }
                }
                OpsPanel("Credit events") {
                    OpsFact("Reserved", formatCount(job.reservedCredits))
                    OpsFact("Refunded", refundedLabel(job.state, job.refundedCredits))
                }
            }
        }
    }
}
